<template>
        <div class="app_tree" v-if="leftMenuShow">
         <div class="app_tree_title">
           <img @click="goBack" src="../../assets/image/learnmodel/back@2x.png" alt="">{{courseName}}
           <ZlProgress v-model="progress" style="position:absolute;left:50%;width:40%;margin-left: 5%;display:flex;align-items:center;"></ZlProgress>
         </div>
          <el-menu
          style="height:100%;"
          ref="menus"
          :default-active = "defaultExpansion"
          :default-openeds="treeDataClone"
          @close="handleClose"
          @select="handleNodeClick"
          >
          <zl-sidebar1 :data="treeData"></zl-sidebar1>
          </el-menu>
        </div>
      </template>

      <script>
      import * as api from "../../api/courseApi";
      import zlSidebar1 from "./zl-sidebar-show1.vue"
      import ZlProgress from './progress.vue'
      /**
       *        新课程目录树，可修改新增，拖拽
       *              -- Author by wjl. on 2021.7.2
       */
      export default {
        name:"zl-sidebar",
        props: {
          courseId: {
            type: [String, Number],
            default: 0,
          },
          subjectId: {
            type: [String, Number],
            default: 0,
          },
          isShow:{
            type:Boolean,
            default:false,
          },
          leftMenuShow:{
            type:Boolean,
            default:false,
          },
          courseName:{
            type: String,
            default: ''
          }
        },
        components:{
          zlSidebar1,
          ZlProgress
        },
        data() {
          return {
            treeData: [],
            treeDataClone: [],
            defaultExpansion: '0', //默认展开的目录
            height: '100%',
            defaultProps: {
              //目录配置
              children: "children",
              label: "catalogName",
            },
            // 2021.7.6
            popover_visible: false,
            iconIsShow: -1,
            // 2021.7.12
            oldCatalogName: "",
            progress:0
          };
        },
        created() {
          this.getCourseCatalog();
        },
        watch:{
          treeData: {
            handler(val) {
              if(val.length>0){
                this.treeDataClone = this.paiping(val).map((val,ind)=>{
                  return String(val.id)
                })
              }
            },
            immediate: true,
            deep: true,
          },
          defaultExpansion: {
            handler(val) {
              console.log(val)
              console.log(this.prev(this.treeDat))
            },
            immediate: true,
            deep: true,
          },
        },
        mounted() {


        },
        methods: {
          goBack(){
            this.$router.go(-1)
          },
          paiping(arr){
              let arr1 = []
              arr.forEach((val)=>{
                arr1.push(val)
                if(val.children.length>=1){
                    arr1 = arr1.concat(this.paiping(val.children))
                }
              })
              return arr1
          },
          // 获取根节点菜单
          getChildList(val){
            let arr1 = []
              val.forEach((val)=>{
                if(val.children.length>=1){
                    arr1 = arr1.concat(this.getChildList(val.children))
                }else{
                  arr1.push(val)
                }
              })
              return arr1
          },
          // 选择下一节
          nextCourse(){
            console.log(this.defaultExpansion)
          },
          getCourseCatalog() {
            //获取课程目录
            api
              .getCourseAllCatalog(this.courseId)
              .then((res) => {
                if (res.code == 0) {
                  if (res.data.length > 0) {
                    this.treeData = res.data;
                    this.$nextTick(() => {
                      // 默认高亮选中节点
                     let moren = sessionStorage.getItem('handleTreeNodeClick');
                     if (moren){
                       let data = JSON.parse(moren)
                      this.defualtOne(data)
                     }else{
                       if (this.treeData[0].children && this.treeData[0].children.length){
                          if (this.treeData[0].children[0].children && this.treeData[0].children[0].children.length){
                            this.defualtOne(this.treeData[0].children[0].children[0])
                          }else{
                            this.defualtOne(this.treeData[0].children[0])
                          }
                       }
                     }
                    });
                  }
                } else {
                  this.$messageError(res.msg);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          },
          defualtOne(data){
            this.$nextTick(()=>{
              console.log(data)
              this.defaultExpansion = String(data.id);
              // this.$refs.tree.setCurrentKey(this.defaultExpansion);
            })
            this.$emit("handleTreeNodeClick", data);
            sessionStorage.setItem('handleTreeNodeClick', JSON.stringify(data))
          },
          handleNodeClick(index,indexPath) {
            let data = {}
            this.paiping(this.treeData).forEach((val,ind)=>{
              if(val.id == index){
                data = val
              }
            })
            if (!data.catalogName) return;
            //点击课程目录
            this.$emit("handleTreeNodeClick", data);
            sessionStorage.setItem('handleTreeNodeClick', JSON.stringify(data))
          },
          openSelectType() {
            this.popover_visible = true;
          },
          handleClose(key, keyPath) {
            console.log(key, keyPath)
            this.$refs.menus.open(key,keyPath);
          },
          prev(){
            return this.getChildList(this.treeData)
          }
        },
      };
      </script>
      <style scoped lang="scss">
      .app_tree {
        min-width: 200px;
        height:100%;
        background: #fff;
        // margin: 0 15px;
        border-right: 1px solid #979797;
        .app_tree_title{
          height: 70px;
          line-height: 70px;
          text-indent: 20px;
          font-size: 13px;
          color: #333333;
          display: flex;
          align-items: center;
          padding-left: 20px;
          border-bottom: 1px solid #D4D4D4;
          position: relative;
          img{
            width: 25px;
            height: 25px;
            margin-right: 8px;
          }
        }
        /deep/ .el-tree-node__content {
          /* height: 40px;
          margin-bottom: 10px; */
          border-radius: 5px;
          /* background: #2b2a33; */
          .custom-tree-node {
            padding-right: 8px;
            width: 100%;
            color: #000;
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            /*font-size: 15px;*/
            position: relative;
          }
          .catalogedtordel {
            display: inline-block;
            margin-right: 4px;
          }
          .el-icon-circle-plus-outline {
            margin: 0 3px;
            display: none;
            line-height: 40px;
            font-size: 15px;
          }
          .selectType {
            width: 120px;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 5000;
          }
        }
        /deep/ .el-tree-node__children .el-tree-node__content {
          background: #f6f6f6;
          margin-bottom: 4px;
          .custom-tree-node {
            color: #2b2a33;
          }
          &:hover {
            background: #ededed;
          }
        }
        /deep/ .el-tree-node__children {
          .el-tree-node__content {
            margin-left: 10px;
            padding-left: 0px !important;
          }
          .el-tree-node__children {
            .el-tree-node__content {
              margin-left: 20px;
              padding-left: 0px !important;
            }
            .el-tree-node__children {
              .el-tree-node__content {
                margin-left: 30px;
                padding-left: 0px !important;
              }
            }
          }
        }
        /deep/
          .el-tree--highlight-current
          .el-tree-node__children
          .el-tree-node.is-current
          > .el-tree-node__content {
          /* background: #007ced; */
            font-size:16px;
          .custom-tree-node {
            color: #000;
          }
        }
        .tree-node-block {
          display: inline-block !important;
        }


        /deep/ .el-submenu__icon-arrow{
          width: 0px;
          height: 0px;
          color:#fff;
        }
         /deep/ .el-submenu .el-menu-item{
          height: 30px;
          line-height: 30px;
        }
        /deep/ .el-submenu__title{
          height: 30px;
          line-height: 30px;
        }
      }
      </style>



// WEBPACK FOOTER //
// src/views/component/zl-sidebar-show.vue